import { Component, EventEmitter, Input, Output, ViewEncapsulation } from '@angular/core';
import { CHECKSHEETSETTINGDIALOG, DpadZoneType, TV } from '@core/constants';
import { InputType } from '@core/models/enums';
import { InputParams } from '@core/models/models';
import { SessionStorageService } from '@core/services/common';
import { DpadControlService } from '@core/services/common/dpad-control.service';

@Component({
  selector: 'caremoni-us-menu-right-cs-nyusho',
  templateUrl: './us-menu-right-cs-nyusho.component.html',
  styleUrl: './us-menu-right-cs-nyusho.component.scss',
  encapsulation: ViewEncapsulation.None
})
export class UsMenuRightCsNyushoComponent {
    @Input() headers: any[] = [];
    @Input() midMenuId: number = 0;
    @Input() isShowRightMenu: boolean = true;
    @Input() displayUnits: any[] = [];
    @Input() unitSelected: string[] = [];
    @Input() displayGroups: any[] = [];
    @Input() groupSelected: string[] = [];
    @Input() isSortByRoom: boolean = true;
    @Input() isSortByName: boolean = false;
    @Input() timeRangeSelected: number = 6;
    @Input() marginToTimeSelected: number = 30;
    @Output() onChangeUnitHandle = new EventEmitter();
    @Output() onChangeGroupHandle = new EventEmitter();
    @Output() onChangeTimeRangeHandle = new EventEmitter();
    @Output() onChangeMarginToTimesHandle = new EventEmitter();
    @Output() onNyuShoRadioClickHandle = new EventEmitter();

    DpadZoneType = DpadZoneType;

    TV = TV;
    CHECKSHEETSETTINGDIALOG = CHECKSHEETSETTINGDIALOG;
    timeRanges: any[] = [6, 5, 4, 3, 2, 1];
    marginToTimes: any[] = [0, 5, 10, 15, 30, 45, 60];
    isNyuSho: boolean = true;
    currentHeaders: any[] = [];
    inputParams: InputParams = {
        type: InputType.number,
        validate: false,
        readonly: false,
        disabled: false,
        maxLength: 100,
        borderFill: false,
        tabindex: 20
    };
    constructor(
        private dpadControlService: DpadControlService,
        private sessionStorageService: SessionStorageService,
    ) { }

    async ngOnInit(): Promise<void>{
    }

    onNyuShoRadioClick(event: any){
        this.onNyuShoRadioClickHandle.emit(event);
    }

    onChangeTimeRange(item: any){
        this.onChangeTimeRangeHandle.emit(item);
    }

    onChangeMarginToTimes(event: any){
        this.onChangeMarginToTimesHandle.emit(event);
    }

    onChangeGroup(event: any){
        this.onChangeGroupHandle.emit(event);
    }
    
    onChangeUnit(event: any){
        this.onChangeUnitHandle.emit(event);
    }

}
